import FilesList from 'components/v2/file-row/FilesList';
import FileUpload from 'components/v2/file-upload/FileUpload';
import { HelpBox } from 'components/v2/help-boxes';
import { Dialog } from 'primereact/dialog';
import { ChangeEvent } from 'react';
import { FileModel } from 'services/EpdClient';
import styled from 'styled-components';

type TProps = {
  files: FileModel[] | undefined;
  isOpened: boolean;
  header: string;
  onHide: any;
  onUpload: any;
  onDelete(fileId: string): void;
  fileLoading?: boolean;
};

const UploadGeneralCertificateDialog = ({ isOpened, header, onHide, files, onUpload, onDelete, fileLoading }: TProps) => {
  const uploadFile = async (e: ChangeEvent<HTMLInputElement>, propertyName: string) => {
    const target = e.target as HTMLInputElement;
    let file = target && target.files && target.files[0];
    if (!file) {
      return null;
    }

    onUpload && onUpload(propertyName, file);
  };
  return (
    <Dialog
      header={<span style={{ marginBottom: 15 }}>{header ?? 'Upload documents'}</span>}
      visible={isOpened}
      style={{ width: 560, minHeight: 220 }}
      onHide={onHide}
      footer={null}
    >
      <DialogContentContainer>
        <HelpBox>
          <span>
            Please upload the <b>main process certificate</b> (PDF) here. It must cover the manufacturing sites, product
            categories, PCR version(s), and GPI version(s). The main certificate will be saved per each EPD copy.
          </span>
        </HelpBox>
        <FileUpload
          label="Upload certificate"
          name="ProcessCertificate"
          icon="pi pi-upload"
          accept=".pdf"
          validExtensions={['pdf']}
          onFileUpload={uploadFile}
          disabled={files?.length! > 0}
        />
        <FilesList files={files} onRemoveFile={onDelete} fileLoading={fileLoading} />
      </DialogContentContainer>
    </Dialog>
  );
};

const DialogContentContainer = styled.div`
  padding: 0 2rem 2rem 2rem;
  overflow-y: auto;
`;

export default UploadGeneralCertificateDialog;
